import actions from './actions';

const { 
    QR_DASHBOARD_DATA_BEGIN, QR_DASHBOARD_DATA_SUCCESS, QR_DASHBOARD_DATA_ERR,
    QR_PAYMENT_INFO_DATA_BEGIN, QR_PAYMENT_INFO_DATA_SUCCESS, QR_PAYMENT_INFO_DATA_ERR,
} = actions;

const initialStateArray = { data: [], loading: false, error: null, };

// QR Dashboard Data Reducers
export const qrDashboardDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case QR_DASHBOARD_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case QR_DASHBOARD_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case QR_DASHBOARD_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

// QR Payment Information Data Reducers
export const qrPaymentInfoDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case QR_PAYMENT_INFO_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case QR_PAYMENT_INFO_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case QR_PAYMENT_INFO_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};